import {
  canMatchAuthGuard,
  canActivateAuthGuard
} from './guards/auth/auth.guard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Roles } from './models/security/roles';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from './models/security/permission.model';
import { redirectFromSpaPathGuard } from './guards/spa/redirect-from-spa-path.guard';
import { AuthGuardWithParams } from './services/auth-guards/auth-guard-with-params.ts.service';
import { TranslateModule } from '@ngx-translate/core';

const supportFormUrl = 'https://erp.tekus.co/helpdesk/atencion-al-cliente-1';

const routes: Routes = [
  {
    path: 'spa',
    children: [
      {
        path: '**',
        canActivate: [redirectFromSpaPathGuard],
        children: []
      }
    ]
  },
  {
    path: 'Spa',
    children: [
      {
        path: '**',
        canActivate: [redirectFromSpaPathGuard],
        children: []
      }
    ]
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./components/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'qa/:id',
    loadChildren: () =>
      import('./components/page-qr-action/page-qr-action.module').then(
        (m) => m.PageQrActionModule
      )
  },
  {
    path: 'transaction/:id',
    loadComponent: () =>
      import('./components/transaction/transaction.component').then(
        (c) => c.TransactionComponent
      )
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'soporte',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'express-support',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'soporte-expres',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'start',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    loadChildren: () =>
      import('./components/start/start.module').then((m) => m.StartModule),
    data: {
      permissions: [
        new Permission('Messages', 'Index'),
        new Permission('Kiosks', 'Index'),
        new Permission('Devices', 'Index')
      ],
      roles: [Roles.Tenant, Roles.TenantLocation]
    }
  },
  {
    path: 'loader/:params',
    loadChildren: () =>
      import('src/app/components/shared/loader-media/loader-media.module').then(
        (m) => m.LoaderMediaModule
      )
  },
  {
    path: 'screen-registration',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    loadChildren: () =>
      import(
        './products/screens/components/devices/screen-registration/screen.registration.module'
      ).then((m) => m.ScreenRegistrationModule),
    data: {
      breadcrumb: 'device.RegisterScreen'
    }
  },
  {
    path: 'account/resetPassword',
    loadChildren: () =>
      import(
        './components/account-management/reset-password/reset-password.module'
      ).then((m) => m.ResetPasswordModule),
    data: {
      breadcrumb: {
        '': ''
      }
    }
  },
  {
    path: 'account/registration/:id',
    canActivate: [AuthGuardWithParams],
    loadChildren: () =>
      import(
        './components/account-management/registration/registration.module'
      ).then((m) => m.RegistrationModule),
    data: {
      param: 'id',
      redirectTo: 'login',
      breadcrumb: 'registration.Registration'
    }
  },
  {
    path: 'account/email-verification',
    canActivate: [AuthGuardWithParams],
    loadChildren: () =>
      import(
        './components/account-management/email-verification/email-verification.module'
      ).then((m) => m.EmailVerificationModule),
    data: {
      queryParam: 'userId,code',
      redirectTo: 'login',
      breadcrumb: 'emailVerification.EmailVerification'
    }
  },
  {
    path: '',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    data: {
      permissions: [
        new Permission('Messages', 'Index'),
        new Permission('Kiosks', 'Index'),
        new Permission('Devices', 'Index')
      ],
      roles: [Roles.Tenant, Roles.TenantLocation]
    },
    loadChildren: () =>
      import('./components/layout/layout.module').then((m) => m.LayoutModule)
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, {
    bindToComponentInputs: true
  })],
  exports: [RouterModule,TranslateModule ]
})
export class AppRoutingModule { }
